import { createSelector, createSlice } from "@reduxjs/toolkit";

import { getUsers } from "./userActions";

import { authActions } from "../auth/authSlice";

import { RootState } from "../../store";
import { IUser } from "../../types/api";
import { IStateDefaults } from "../../types/shared";

export interface UserState extends IStateDefaults {
    users: IUser[];
}

const initialState: UserState = {
    loading: false,
    success: false,
    users: [],
};

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(authActions.logout, state => {})
            .addCase(getUsers.fulfilled, (state, { payload }) => {
                state.users = payload.users;
            });
    },
});

export const userActions = {
    ...userSlice.actions,
    getUsers: getUsers,
};

export default userSlice.reducer;

export const selectUsers = createSelector(
    [(state: RootState) => state.user],
    user => user.users,
);

export const selectUser = createSelector(
    [
        (state: RootState) => state.user.users,
        (state: RootState, userId: number) => userId,
    ],
    (users, userId) => users.find(user => user.id === userId),
);
